import { useEffect, useState } from 'react';
import { clientConfig } from '../config/clientConfig';
import { consentManager } from '../utils/consentManager';

export default function GoogleTagManager() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const checkAndLoad = async () => {
      // Skip GTM loading if disabled for this environment
      if (!clientConfig.isGoogleTagManagerEnabled) {
        return;
      }

      // Check if we should load GTM (handles California vs non-California logic)
      const canLoad = await consentManager.shouldLoadGTM();
      
      if (canLoad) {
        setShouldLoad(true);
      }
    };

    checkAndLoad();

    // Listen for user interaction event (from California users clicking buttons)
    const handleUserInteraction = () => {
      // Only load if GTM is enabled for this environment
      if (clientConfig.isGoogleTagManagerEnabled) {
        setShouldLoad(true);
      }
    };

    window.addEventListener('userInteracted', handleUserInteraction);

    return () => {
      window.removeEventListener('userInteracted', handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    if (!shouldLoad) {
      return;
    }

    const gtmContainer = clientConfig.gtmContainer;

    // Add GTM script
    const script = document.createElement('script');
      const serverUrl = gtmContainer.url;
      const loadServerUrl = serverUrl.replace('s.', 'load.s.');
      const iId = gtmContainer.iId;
      const cId = gtmContainer.cId;
      
      script.innerHTML = `!function(){"use strict";function l(e){for(var t=e,r=0,n=document.cookie.split(";");r<n.length;r++){var o=n[r].split("=");if(o[0].trim()===t)return o[1]}}function s(e){return localStorage.getItem(e)}function u(e){return window[e]}function A(e,t){e=document.querySelector(e);return t?null==e?void 0:e.getAttribute(t):null==e?void 0:e.textContent}var e=window,t=document,r="script",n="dataLayer",o="${serverUrl}",a="${loadServerUrl}",i="${iId}",c="${cId}",g="stapeUserId",v="",E="",d=!1;try{var d=!!g&&(m=navigator.userAgent,!!(m=new RegExp("Version/([0-9._]+)(.*Mobile)?.*Safari.*").exec(m)))&&16.4<=parseFloat(m[1]),f="stapeUserId"===g,I=d&&!f?function(e,t,r){void 0===t&&(t="");var n={cookie:l,localStorage:s,jsVariable:u,cssSelector:A},t=Array.isArray(t)?t:[t];if(e&&n[e])for(var o=n[e],a=0,i=t;a<i.length;a++){var c=i[a],c=r?o(c,r):o(c);if(c)return c}else console.warn("invalid uid source",e)}(g,v,E):void 0;d=d&&(!!I||f)}catch(e){console.error(e)}var m=e,g=(m[n]=m[n]||[],m[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"}),t.getElementsByTagName(r)[0]),v=I?"&bi="+encodeURIComponent(I):"",E=t.createElement(r),f=(d&&(i=8<i.length?i.replace(/([a-z]{8}$)/,"kp$1"):"kp"+i),!d&&a?a:o);E.async=!0,E.src=f+"/"+i+".js?"+c+v,null!=(e=g.parentNode)&&e.insertBefore(E,g)}();`;
    
    document.head.appendChild(script);

    // Add GTM noscript iframe
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    
      // Server-side GTM noscript for Symplelending production
    iframe.src = `${loadServerUrl}/ns.html?id=${gtmContainer.containerId}`;
    
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    return () => {
      if (document.head.contains(script)) {
      document.head.removeChild(script);
      }
      if (document.body.contains(noscript)) {
      document.body.removeChild(noscript);
      }
    };
  }, [shouldLoad]);

  return null;
}